module.exports = "/build/web/images/logo-sikkens.eaeb16ea3273a1fb3a7f95426efb0451.png";


//////////////////
// WEBPACK FOOTER
// ./images/logo-sikkens.png
// module id = 127
// module chunks = 11